import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Chevron } from 'src/components/ui/Features/Chevron/Chevron';
import { useWordList } from 'src/hook/data/useWordList';
import { ChevronType, SortType } from 'src/model/enum/enums';
import styles from './ListViewHeader.module.scss';
import Menu from './Menu/Menu';

interface ListViewHeaderProps {
    selectedItem: SortType;
    setSelectedItem: (selectedItem: SortType) => void;
    title: string;
}


export const ListViewHeader = ({ selectedItem, setSelectedItem, title }: ListViewHeaderProps) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    return (
        <section className={styles.listViewHeader}>
            <Chevron type={ChevronType.Left} onClick={() => navigate('/')} />
            <h1>{title}</h1>
            <span ref={menuRef} onClick={() => setIsMenuOpen(!isMenuOpen)}
                className={styles.menu}>•••</span>

            <Menu
                isOpen={isMenuOpen}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                onClose={() => setIsMenuOpen(false)}
                trigger={menuRef.current}
            />
        </section>
    );
};
